var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"configurator-text-row"},_vm._l((_vm.matchedOffers),function([key, ref]){return _c('item-component',{key:ref.offer.id,attrs:{"item":ref,"option":_vm.option.options[key],"current":_vm.current},on:{"select":function($event){return _vm.$emit('select', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }